import { IInvoice } from 'src/types/invoice';
import CaseEnum from '../../enumerables/case-enum';
import GeneralEnum from '../../enumerables/general-enum';
import { getValFromEnum } from '../../components/redux-form/utils/dropdown-values';
import * as React from 'react';
import { changeToZeroMoment } from '../timeHelpers';
import { numberWithCommas } from '../format';

export const DetailInvoice: React.FunctionComponent<any> = (data: Partial<IInvoice>): any => {
    const statusEnum = GeneralEnum ? GeneralEnum.getEnum('InvoiceStatus') : {};

    const statuses: SelectObject[] = getValFromEnum(statusEnum);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let valuestatus: any = {};

    const occasion = data.occasion;

    statuses.forEach((it) => {
        /* if (+it.value !== 2 && +it.value !== 7 && +it.value !== 9) {
            arrData.push(it);
        }*/
        if (+it.value === data.status) {
            valuestatus = it;
        }
    });
    valuestatus = valuestatus ? valuestatus.label : '';

    /*   if (occasion?.caseType && +occasion.caseType === 5) {
        statuses.forEach((it) => {
            if (+it.value !== 2 && +it.value !== 7 && +it.value !== 9) {
                arrData.push(it);
            }
            if (+it.value === data.status) {
                valuestatus = it;
            }
        });

        valuestatus = (
            <DropdownList
                data={arrData}
                textField="label"
                valueField="value"
                onChange={(item: any) => {
                    dispatch(
                        persistInvoice(
                            {
                                status: +item.value,
                                id: data.id ? +data.id : 1,
                            },
                            [],
                            {
                                resolve: (value) => {},
                                reject: (reason) => {},
                            },
                        ),
                    ); //this.setState({  valuestatus: valuestatus });
                }}
                value={valuestatus}
            />
        );
    } else {
        if (data.status && +data.status === 5) {
            statuses.forEach((it) => {
                if (+it.value === 6 || +it.value === 5) {
                    arrData.push(it);
                }
                if (+it.value === data.status) {
                    valuestatus = it;
                }
            });

            valuestatus = (
                <DropdownList
                    data={arrData}
                    textField="label"
                    valueField="value"
                    onChange={(item: any) => {
                        dispatch(
                            persistInvoice(
                                {
                                    status: +item.value,
                                    id: data.id ? +data.id : 1,
                                },
                                [],
                                {
                                    resolve: (value) => {},
                                    reject: (reason) => {},
                                },
                            ),
                        ); //this.setState({  valuestatus: valuestatus });
                    }}
                    value={valuestatus}
                />
            );
        } else {
            valuestatus = valuestatus ? valuestatus.label : '';
        }
    }*/

    const invoiceSigners = CaseEnum ? CaseEnum.getEnum(`InvoiceSigner`) : {};
    const invoiceSignersValues: SelectObject[] = getValFromEnum(invoiceSigners);
    const invoiceSignersId = data?.invoiceSigner;
    const valueInvoiceSigner = invoiceSignersValues.find((it) => +it.value === +`${invoiceSignersId}`);
    const invoiceSigner = valueInvoiceSigner ? valueInvoiceSigner.label : '';

    let orderType = '';

    let caseNumber = '';
    let serviceType = '';
    let valueLocation: any = [];
    if (occasion) {
        const orderTypes = CaseEnum ? CaseEnum.getEnum(`OrderType_${occasion?.caseType}`) : {};
        const orderTypesValues: SelectObject[] = getValFromEnum(orderTypes);
        const orderTypeId = occasion?.orderType;
        caseNumber = occasion?.caseNumber ? occasion?.caseNumber : '';
        serviceType = occasion?.serviceType ? occasion?.serviceType?.title : '';
        if (!serviceType) {
            serviceType = occasion?.serviceType ? occasion?.serviceType?.cpt : '';
        }
        const valueOrderType = orderTypesValues.find((it) => +it.value === +`${orderTypeId}`);
        orderType = valueOrderType ? valueOrderType.label : '';

        const occasionServiceLocations: any = occasion?.occasionServiceLocations;
        if (occasionServiceLocations) {
            occasionServiceLocations.forEach((itP: any, k: number) => {
                valueLocation.push(
                    `${itP.serviceLocation?.title} -( from ${changeToZeroMoment(itP.createdAt, 'MMM D, YYYY')}`,
                );
            });
        }

        valueLocation = valueLocation.join(',');
    }

    const dataRow = [
        { name: 'Invoice Number', value: data.invoiceNumber },
        {
            name: 'Invoice Date',
            value: data.createdAt ? `${changeToZeroMoment(data.createdAt, 'MMM D, YYYY')}` : '',
        },
        {
            name: 'Invoice Total',
            value: data.invoiceTotal
                ? `$${numberWithCommas(data.invoiceTotal)}` + ' (' + `$${numberWithCommas(data.actualTotal)}` + ')'
                : '',
        },
        { name: 'Case Number', value: caseNumber },
        { name: 'Order Type', value: orderType },
        { name: 'Invoice Signer', value: invoiceSigner },
        { name: 'Service Type', value: serviceType ? serviceType : '' },
        {
            name: 'Student Full Name',
            value: data.student ? `${data.student.firstName} ${data.student.lastName}` : '',
        },
        { name: 'Status', value: valuestatus },
        /*
        { name: 'Payment Date', value: `${data.paymentDate ? data.paymentDate : ''}` },
        { name: 'Note', value: `${data.note ? data.note : ''}` },*/
    ];

    if (data.status == 10) {
        dataRow.push({ name: 'A written-off reason', value: data.reason });
    }
    if (data.note?.length) {
        dataRow.push({ name: 'Note', value: data.note });
    }

    return dataRow;
};
